import React, {useEffect, useState} from "react";
import axios from "axios";
import {toast} from "react-toastify";
import {useDispatch, useSelector} from "react-redux";
import {
    defaultMyDataReportRequestData,
    setBuysMyDataReportRequestData, setClassificationsReportFrom,
    setClassificationsReportRequestData,
    setClassificationsReportResponseData, setForceRefreshBuysMyDataReport
} from "../../../../_reducers/DataPanel/Buys/buysSlice";
import DateHelper from "../../../primer/DateHelper/DateHelper";
import {Badge, Col, Row, Spinner} from "react-bootstrap";
import DateBox from "../../../primer/DateBox";
import {checkPermission, getGreekCurrencyFormat, isEmpty} from "../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import Button from "react-bootstrap/Button";
import {
    getECTypeOptions,
    getICTypeOptions
} from "../../../../_helpers/sharedmydata";
import Dropdown from "../../../primer/Dropdown";
import Modal from "react-bootstrap/Modal";
import {
    defaultSalesMyDataReportRequestData,
    setForceRefreshMyDataSalesReport,
    setSalesMyDataReportRequestData
} from "../../../../_reducers/DataPanel/Sales/salesSlice";
import {
    openAccountingRecord,
    openBuy,
    openFixedAssetRecord,
    openSale,
    openTabByType
} from "../../../../_helpers/tabOpeners";
import {liberationSerif} from "../../../../fonts/liberationSerif";
import {dejavuSans} from "../../../../fonts/DejaVuSans-normal";
import {dejavuSansBold} from "../../../../fonts/DejaVuSans-Bold-bold";
import { jsPDF } from "jspdf";
import {autoTable} from "jspdf-autotable";
import * as XLSX from "xlsx";
import {useTranslation} from "../../../../hooks/useTranslation";

const ReportsClassifications = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const myDataReportRequestData = useSelector((state) => state.BUYS.myDataReportRequestData);
    const salesMyDataReportRequestData = useSelector((state) => state.SALES.salesMyDataReportRequestData);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const companyDetails = useSelector((state) => state.COMPANY_DATA.companyDetails);
    const [loading, setLoading] = useState(false);
    const [pageChanged, setPageChanged] = useState(false);
    const [iframeSrc, setIframeSrc] = useState();
    const iframeRef = React.createRef();
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));

    const [classDataRow, setClassDataRow] = useState({});
    const [classData, setClassData] = useState({});
    const [showClassModal, setShowClassModal] = useState(false);

    const icType = getICTypeOptions(true);
    const ecType = getECTypeOptions(true);
    const allTypes = [...icType, ...ecType];

    const comingFrom = useSelector((state) => state.BUYS.classificationsReportFrom);
    const requestData = useSelector((state) => state.BUYS.classificationsReportRequestData);
    const responseData = useSelector((state) => state.BUYS.classificationsReportResponseData);

    const docTypes = checkPermission("buys-mydata/mydatareport-read", permissionsData) ?
        [
            {value: "", label: "Προβολή όλων"},
            {value: "sale", label: "Προβολή μόνο πωλήσεων"},
            {value: "buy", label: "Προβολή μόνο αγορών"},
        ] : [
            {value: "sale", label: "Προβολή μόνο πωλήσεων"},
        ]

    useEffect(() => {
        if (requestData.firstLoad || comingFrom) {
            fetchReport(false, false);
        }
    }, [requestData.firstLoad])

    useEffect(() => {
        if (pageChanged) {
            setPageChanged(false);
            fetchReport(true, false);
        }
    }, [pageChanged]);

    useEffect(() => {
        if (showClassModal) {
            fetchClassData();
        } else {
            setClassDataRow({});
            setClassData({});
        }
    }, [showClassModal])

    const handleOnChange = (e, type, name) => {
        let prepChange = {};
        if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        } else if (type === "msdd") {
            prepChange[name] = e.flatMap((o) => o.value);
        } else if (type === "dd") {
            prepChange[name] = e.value;
        }
        dispatch(setClassificationsReportRequestData({...requestData, ...prepChange}));
    }

    const fetchReport = (fromPagination = false, forceRefresh = false) => {
        setLoading(true);
        const reqData = {
            ...requestData,
            firstLoad: false,
            page: (forceRefresh || !fromPagination) ? 1 : requestData.page,
        }
        if (comingFrom) {
            reqData.type = comingFrom;
        }
        dispatch(setClassificationsReportFrom(""));
        dispatch(setClassificationsReportRequestData(reqData));
        axios.post(`${process.env.REACT_APP_API_URL2}/report/classifications-report`, {
            ...reqData,
            company: company.id,
            onlyHook: "true",
            forceRefresh: forceRefresh,
        }, {
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            setLoading(false);
            if (res.data.status === "200") {
                dispatch(setClassificationsReportRequestData({...reqData, ...res.data.filters}))
                dispatch(setClassificationsReportResponseData(res.data));
                if (forceRefresh) toast.success("Τα δεδομένα ανανεώθηκαν.");
            } else {
                if (forceRefresh) toast.error(res.data.message);
            }
        }).catch((err) => {
            setLoading(false);
            console.log(err);
            if (!fromPagination) toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const fetchClassData = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/report/classification-report-e3-data`, {
            date_from: requestData.date_from,
            date_to: requestData.date_to,
            company: company.id,
            matchType: classDataRow.classificationType,
        }, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                setClassData(res.data.data);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handlePage = (str) => {
        if(str === "first") {
            dispatch(setClassificationsReportRequestData({...requestData, page: 1}));
            setPageChanged(true);
        } else if (str === "previous") {
            dispatch(setClassificationsReportRequestData({...requestData, page: requestData.page - 1}));
            setPageChanged(true);
        } else if (str === "next") {
            dispatch(setClassificationsReportRequestData({...requestData, page: requestData.page + 1}));
            setPageChanged(true);
        } else if (str === "last") {
            dispatch(setClassificationsReportRequestData({...requestData, page: responseData.totalPages}));
            setPageChanged(true);
        }
    }

    const handleMDReport = () => {
        const marksDiff = classData.map((o) => {
            if (o.erpExists === false || +Number(+o.myDataValue - +o.erpValue).toFixed(2) !== 0) {
                return o.mark;
            }
            return null;
        }).filter(Boolean);
        if (marksDiff.length > 0) {
            if (classDataRow.type === "sale") {
                if (requestData.date_from !== salesMyDataReportRequestData?.date_from || requestData.date_to !== salesMyDataReportRequestData?.date_to) {
                    dispatch(setForceRefreshMyDataSalesReport("force"));
                } else {
                    dispatch(setForceRefreshMyDataSalesReport("soft"));
                }
                dispatch(setSalesMyDataReportRequestData({...salesMyDataReportRequestData, date_from: requestData.date_from, date_to: requestData.date_to, marks: marksDiff.join(", ")}))
            } else {
                if (requestData.date_from !== myDataReportRequestData?.date_from || requestData.date_to !== myDataReportRequestData?.date_to) {
                    dispatch(setForceRefreshBuysMyDataReport("force"));
                } else {
                    dispatch(setForceRefreshBuysMyDataReport("soft"));
                }
                dispatch(setBuysMyDataReportRequestData({...myDataReportRequestData, date_from: requestData.date_from, date_to: requestData.date_to, marks: marksDiff.join(", ")}))
            }
            const id = classDataRow.type === "sale" ? "mydata-report" : "buys-mydata-report";
            dispatch(openTabByType(id, TABS_DATA));
        } else {
            toast.info("Δεν βρέθηκαν διαφορές.");
        }
    }

    const handleShow = (e, row, onlyDifferences = false) => {
        e.stopPropagation();
        if (row.type === "sale") {
            if (requestData.date_from !== salesMyDataReportRequestData?.date_from || requestData.date_to !== salesMyDataReportRequestData?.date_to) {
                dispatch(setForceRefreshMyDataSalesReport("force"));
            } else {
                dispatch(setForceRefreshMyDataSalesReport("soft"));
            }
            dispatch(setSalesMyDataReportRequestData({
                ...defaultSalesMyDataReportRequestData,
                date_from: requestData.date_from,
                date_to: requestData.date_to,
                classificationTypes: [allTypes.find((el) => el.value === row.classificationType)],
                classified: onlyDifferences ? "classificationsDifference" : "",
            }));
        } else if (row.type === "buy") {
            if (requestData.date_from !== myDataReportRequestData?.date_from || requestData.date_to !== myDataReportRequestData?.date_to) {
                dispatch(setForceRefreshBuysMyDataReport("force"));
            } else {
                dispatch(setForceRefreshBuysMyDataReport("soft"));
            }
            dispatch(setBuysMyDataReportRequestData({
                ...defaultMyDataReportRequestData,
                date_from: requestData.date_from,
                date_to: requestData.date_to,
                classificationTypes: [allTypes.find((el) => el.value === row.classificationType)],
                classified: onlyDifferences ? "classificationsDifference" : "",
            }));
        }
        const id = row.type === "sale" ? "mydata-report" : "buys-mydata-report";
        dispatch(openTabByType(id, TABS_DATA));
    }

    const handleOpenDocument = (row) => {
        if (row.docId) {
           if (row.type === "sale") {
               openSale(dispatch, TABS_DATA, company.id, row.docId);
           } else if (row.type === "buy") {
               openBuy(dispatch, TABS_DATA, company.id, row.docId);
           } else if (row.type === "record") {
               openAccountingRecord(dispatch, TABS_DATA, company.id, row.docId);
           } else if (row.type === "assetRecord") {
               openFixedAssetRecord(dispatch, TABS_DATA, company.id, row.docId);
           }
        }
    }

    const handlePDFExport = async (printer = false) => {
        if (loading) return;
        setLoading(true);
        const reqData = {
            ...requestData,
            firstLoad: false,
            forExport: true,
            page: 1,
            company: company.id,
            onlyHook: "true",
            forceRefresh: false
        }
        if (comingFrom) {
            reqData.type = comingFrom;
        }
        const response = await axios.post(`${process.env.REACT_APP_API_URL2}/report/classifications-report`, reqData, { headers: { "Content-Type": "application/json" }, })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
        const responseData = response.data?.data;

        const doc = new jsPDF('landscape');
        let y = 23;
        doc.addFileToVFS("arialuni.ttf", liberationSerif);
        doc.addFont("arialuni.ttf", "Arial Unicode MS", "normal");
        doc.addFileToVFS("dejavusans.ttf", dejavuSans);
        doc.addFont("dejavusans.ttf", "DejaVu Sans Normal", "normal");
        doc.addFileToVFS("dejavusansBold.ttf", dejavuSansBold);
        doc.addFont("dejavusansBold.ttf", "DejaVu Sans Bold", "normal");
        doc.setFont("DejaVu Sans Bold");
        doc.setFontSize(12);
        let dateFrom = requestData.date_from;
        let dateTo = requestData.date_to;
        if (isEmpty(dateFrom)) dateFrom = moment(company.year, "YYYY", true).startOf("year").format("DD/MM/YYYY");
        if (isEmpty(dateTo)) dateTo = moment(company.year, "YYYY", true).endOf("year").format("DD/MM/YYYY");
        const header = doc.splitTextToSize(`Χαρακτηρισμοί Αγορών από ${dateFrom} έως ${dateTo}`, 200);
        const headerString = header.join("\n");
        doc.text(headerString, doc.internal.pageSize.getWidth() / 4, 9, {alignment: "center"});
        doc.setFont("DejaVu Sans Normal");
        doc.setFontSize(9);
        doc.text(`${company.name}, ΑΦΜ: ${company.vatNumber}`, 15, 17, {alignment: "center"});
        doc.text(`ΔΟΥ: ${companyDetails.doy}`, 15, 21, {alignment: "center"});
        doc.text(`Ημερομηνία Εξαγωγής: ${moment().format("DD/MM/YYYY")}`, 190, 21, {alignment: "center"});
        const imgData = 'assets/images/prrimer-logo.png';
        const imgX = doc.internal.pageSize.getWidth() - 45; // adjust the position as needed
        const imgY = 3; // adjust the position as needed
        doc.addImage(imgData, 'PNG', imgX, imgY, 40, 15);
        doc.setFont("DejaVu Sans Normal");
        const columns1 = ["Αρ.", "Κατηγορία Εγγράφου", "Τύπος MyData", "Περιγραφή Τύπου MyData", "Αξία MyData", "Αξία ERP", "Διαφορά"]
        let rows = [];
        if(responseData?.length > 0) {
            responseData.forEach((row) => {
                rows.push([
                    {content: row.no, styles: {halign: "left"}},
                    {content: row.type === "sale" ? "Πώληση" : row.type === "buy" ? "Αγορά" : row.type === "record" ? "Λογιστική" : "-", styles: {}},
                    {content: row.classificationType, styles: {}},
                    {content: allTypes.find((el) => el.value === row.classificationType)?.label, styles: {}},
                    {content: getGreekCurrencyFormat(row.myDataValue.toFixed(2)), styles: {}},
                    {content: getGreekCurrencyFormat(row.erpValue.toFixed(2)), styles: {}},
                    {content: getGreekCurrencyFormat((row.myDataValue - row.erpValue).toFixed(2)), styles: {}},
                ])
            })
        }
        autoTable(doc, {
            startY: y,
            head: [columns1],
            body: rows,
            rowPageBreak: "avoid",
            styles: {
                font: "DejaVu Sans Normal",
                fontStyle: "normal",
                fontSize: 8, // set font size
                halign: "center", // set alignment
            },
        })
        const pageCount = doc.getNumberOfPages();
        // Add the pagination to each page
        for (let i = 1; i <= pageCount; i++) {
            doc.setPage(i);
            doc.setFontSize(10);
            doc.text(`Σελίδα ${i} από ${pageCount}`, 10, doc.internal.pageSize.getHeight() - 10);
        }
        if (printer) {
            setIframeSrc(`${doc.output('bloburl')}`);
        } else {
            doc.save("Χαρακτηρισμοί-Αγορών.pdf");
        }
        setLoading(false);
    }

    const handleExcelExport = async () => {
        if (loading) return;
        setLoading(true);
        const reqData = {
            ...requestData,
            firstLoad: false,
            forExport: true,
            page: 1,
            company: company.id,
            onlyHook: "true",
            forceRefresh: false
        }
        if (comingFrom) {
            reqData.type = comingFrom;
        }
        const response = await axios.post(`${process.env.REACT_APP_API_URL2}/report/classifications-report`, reqData, { headers: { "Content-Type": "application/json" }, })
            .catch((err) => {
                console.error(err);
                setLoading(false);
            });
        const responseData = response.data?.data;

        let dR = [];
        if (responseData?.length > 0) {
            responseData.forEach((row) => {
                let obj = {
                    "Αρ.": row.no,
                    "Κατηγορία Εγγράφου": row.type === "sale" ? "Πώληση" : row.type === "buy" ? "Αγορά" : row.type === "record" ? "Λογιστική" : "-",
                    "Τύπος MyData": row.classificationType,
                    "Περιγραφή Τύπου MyData": allTypes.find((el) => el.value === row.classificationType)?.label,
                    "Αξία MyData": +(row.myDataValue.toFixed(2)),
                    "Αξία ERP": +(row.erpValue.toFixed(2)),
                    "Διαφορά": +((row.myDataValue - row.erpValue).toFixed(2)),
                };
                dR.push(obj);
            });
        }
        const worksheet = XLSX.utils.json_to_sheet(dR);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "Χαρακτηρισμοί Αγορών.xlsx");
        setLoading(false);
    }

    const handleIframeLoad = () => {
        if (iframeSrc && iframeRef.current) {
            const iframeWindow = iframeRef.current.contentWindow;
            iframeWindow.print();
        }
    }

    const formatRowType = (rowType) => {
        if (rowType === "sale") return "Πώληση";
        else if (rowType === "buy") return "Αγορά";
        else if (rowType === "record") return "Λογ. Εγγραφή";
        else if (rowType === "assetRecord") return "Αποσβέσεις";
        else return "-";
    }

    return (
        <React.Fragment>
            <div style={{display: "none"}} className="print-me" id="printReport">
                <iframe onLoad={() => handleIframeLoad()} ref={iframeRef} style={{width: "100%"}} src={iframeSrc} title={"Print Report"}></iframe>
            </div>
            <Row className={"mb-2"}>
                <Col md={2}>
                    <DateHelper
                        dateFromAndToFunction={(from, to) => dispatch(setClassificationsReportRequestData({
                            ...requestData,
                            date_from: from,
                            date_to: to
                        }))}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name={"date_from"}
                        selected={moment(requestData.date_from, "DD/MM/YYYY").isValid() ? moment(requestData.date_from, "DD/MM/YYYY").toDate() : null}
                        label={t('SalesMyData.dateFrom')}
                        onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                        allowOtherYears={false}
                    />
                </Col>
                <Col md={2}>
                    <DateBox
                        name={"date_to"}
                        selected={moment(requestData.date_to, "DD/MM/YYYY").isValid() ? moment(requestData.date_to, "DD/MM/YYYY").toDate() : null}
                        label={t('SalesMyData.dateTo')}
                        onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                        allowOtherYears={false}
                    />
                </Col>
                <Col md={3}>
                    {!isEmpty(requestData.lastUpdate) && (
                        <Badge bg={"primary"} style={{marginTop: "26px"}}>
                            Τελευταία ανανέωση από το My Data: <br/>
                            {requestData.lastUpdate}
                        </Badge>
                    )}
                </Col>
                <Col md={3} className={"d-flex justify-content-end"}>
                    <Button onClick={() => fetchReport(false, true)} style={{marginTop: "22px"}} disabled={loading}>Άντληση
                        χαρακτηρισμών από το My Data {loading &&  <Spinner className={"ml-2"} animation="border" variant="dark" />}</Button>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <Dropdown
                        name={"type"}
                        options={docTypes}
                        label={"Τύπος Εγγράφου"}
                        defaultValue={docTypes.find((el) => el.value === requestData.type)}
                        onChange={(e) => handleOnChange(e, "dd", "type")}
                    />
                </Col>
                <Col md={4}>
                    <Dropdown
                        name={"classificationType"}
                        options={allTypes}
                        label={"Τύπος MyData"}
                        defaultValue={allTypes.filter((el) => requestData.classificationType.includes(el.value))}
                        onChange={(e) => handleOnChange(e, "msdd", "classificationType")}
                        multiSelect={true}
                    />
                </Col>
                <Col md={3}>
                    <Button onClick={() => fetchReport(false, false)} className={"float-right"} disabled={loading}
                            style={{marginTop: "22px"}}>
                        Εφαρμογή φίλτρων {loading &&  <Spinner className={"ml-2"} animation="border" variant="dark" />}
                    </Button>
                </Col>
            </Row>

            {responseData.totalPages > 0 && (
                <React.Fragment>
                    <Badge key={"b5"} bg={"primary"} style={{userSelect: "none", cursor: "pointer"}} className={"ml-1"}
                           onClick={() => handlePDFExport(true)}>Εκτύπωση</Badge>
                    <Badge key={"b5"} bg={"primary"} style={{userSelect: "none", cursor: "pointer"}} className={"ml-4"}
                           onClick={() => handlePDFExport()}>Εξαγωγή PDF</Badge>
                    <Badge key={"b4"} bg={"primary"} style={{userSelect: "none", cursor: "pointer"}} className={"ml-4"}
                           onClick={() => handleExcelExport()}>Εξαγωγή XLSX</Badge>
                    <div className={"d-flex justify-content-end"}>
                        <Button size={"sm"} className={"mr-1"} disabled={requestData.page === 1}
                                onClick={() => handlePage("first")}>{t('SalesMyData.first')}</Button>
                        <Button size={"sm"} className={"mr-1"} disabled={requestData.page === 1}
                                onClick={() => handlePage("previous")}>{t('SalesMyData.previous')}</Button>
                        <Badge style={{fontSize: "12px", lineHeight: "20px"}} className="mr-1"
                               bg="primary">{t('SalesMyData.page')} {requestData.page} / {responseData.totalPages}</Badge>
                        <Button size={"sm"} className={"mr-1"} disabled={requestData.page === responseData.totalPages}
                                onClick={() => handlePage("next")}>{t('SalesMyData.next')}</Button>
                        <Button size={"sm"} className={"mr-1"} disabled={requestData.page === responseData.totalPages}
                                onClick={() => handlePage("last")}>{t('SalesMyData.last')}</Button>
                    </div>
                    <Row className={"mt-2"}>
                        <Col md={12}>
                            <table className={"simpleClassicTable simpleClassicTableHoverable"}>
                                <colgroup>
                                    <col span={1} style={{width: "5%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "15%"}}></col>
                                    <col span={1} style={{width: "30%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                    <col span={1} style={{width: "10%"}}></col>
                                </colgroup>
                                <thead>
                                <tr>
                                    <th>Αρ.</th>
                                    <th>Κατηγορία Εγγράφου</th>
                                    <th>Τύπος MyData</th>
                                    <th>Περιγραφή Τύπου MyData</th>
                                    <th>Αξία MyData</th>
                                    <th>Αξία ERP</th>
                                    <th>Διαφορά</th>
                                    <th>Ενέργειες</th>
                                </tr>
                                </thead>
                                <tbody>
                                {responseData.data.map((row, idx) => (
                                    <tr key={`classTable-${idx}`} style={{
                                        cursor: "pointer",
                                        backgroundColor: row.difference === true ? "lightyellow" : "#bffcbd"
                                    }} onClick={() => {
                                        setClassDataRow(row);
                                        setShowClassModal(true);
                                    }}>
                                        <td>{row.no}</td>
                                        <td>{row.type === "sale" ? "Πώληση" : row.type === "buy" ? "Αγορά" : "-"}</td>
                                        <td>{isEmpty(row.classificationType) ? "Κενό" : row.classificationType}</td>
                                        <td>{!isEmpty(row.classificationType) ? (
                                            <span>{allTypes.find((el) => el.value === row.classificationType)?.label}</span>
                                        ) : (
                                            <span>Κενό</span>
                                        )}</td>
                                        <td>{getGreekCurrencyFormat(row.myDataValue)}</td>
                                        <td>{getGreekCurrencyFormat(row.erpValue)}</td>
                                        <td>{getGreekCurrencyFormat(+Number(+row.myDataValue - +row.erpValue).toFixed(2))}</td>
                                        <td>
                                            <Badge bg={"primary"}
                                                   onClick={(e) => handleShow(e, row, false)}
                                                   title={"Προβολή ιδίου Ε3 στην αναφορά MyData"}
                                            >
                                                <i className="fa-solid fa-bars"></i>
                                            </Badge>
                                            {row.difference && (
                                                <Badge bg={"primary"}
                                                       onClick={(e) => handleShow(e, row, true)}
                                                       className={"ml-1"}
                                                       title={"Προβολή διαφορών ιδίου Ε3"}
                                                >
                                                    <i className="fa-solid fa-indent"></i>
                                                </Badge>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                    <Row className={"d-flex justify-content-end mt-2"}>
                        <Col md={4}>
                            <table className={"simpleClassicTable"}>
                                <tbody>
                                <tr>
                                    <td style={{fontWeight: "700"}}>Σύνολο myDATA</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.myDataValue)}</td>
                                </tr>
                                <tr>
                                    <td style={{fontWeight: "700"}}>Σύνολο ERP</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.erpValue)}</td>
                                </tr>
                                <tr>
                                    <td style={{fontWeight: "700"}}>Σύνολο Διαφορών</td>
                                    <td>{getGreekCurrencyFormat(responseData.totals.difference)}</td>
                                </tr>
                                </tbody>
                            </table>
                        </Col>
                    </Row>
                </React.Fragment>
            )}

            <Modal show={showClassModal} onHide={() => setShowClassModal(false)}
                   dialogClassName={"modal65PercentWidth"}>
                <Modal.Header closeButton>
                    <Modal.Title>Αναφορά χαρακτηρισμών</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {Object.keys(classData).length > 0 && (
                        <React.Fragment>
                            Με κίτρινο χρώμα αποτυπόνονται τα παραστατικά που υπάρχει διαφορά χαρακτηρισμών, με κόκκινο
                            αυτά που δεν υπάρχουν στο ERP, με πράσινο αυτά που συμφωνούν στο συγκεκριμένο Ε3.
                            <div style={{maxHeight: "50vh", overflowY: "auto"}} className={"mt-2"}>
                                <table className={"simpleClassicTable"} style={{position: "sticky", top: "0px"}}>
                                    <thead>
                                    <tr>
                                        <th>MARK</th>
                                        <th>Κατηγορία</th>
                                        <th>Παραστατικό</th>
                                        <th>Αξία MyData</th>
                                        <th>Αξία ERP</th>
                                        <th>Διαφορά</th>
                                    </tr>
                                    </thead>
                                </table>
                                <table className={"simpleClassicTable"}>
                                    <tbody>
                                    {classData.map((row, idx) => (
                                        <tr key={`classDataTable-${idx}`}
                                            style={{backgroundColor: row.erpExists === true ? +Number(+row.myDataValue - +row.erpValue).toFixed(2) === 0 ? "#bffcbd" : "lightyellow" : "#ffb5b0"}}>
                                            <td>{row.mark}</td>
                                            <td>{formatRowType(row.type)}</td>
                                            <td>{row.docId ? (
                                                <div style={{textDecoration: "underline", cursor: "pointer"}}
                                                     onClick={() => handleOpenDocument(row)}>{row.identifier}</div>
                                            ) : "-"}</td>
                                            <td>{getGreekCurrencyFormat(row.myDataValue)}</td>
                                            <td>{getGreekCurrencyFormat(row.erpValue)}</td>
                                            <td>{getGreekCurrencyFormat(+Number(+row.myDataValue - +row.erpValue).toFixed(2))}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                            <Button size={"sm"} className={"mt-2"} onClick={() => handleMDReport()}>Προβολή διαφορών
                                στην Αναφορά MyData</Button>
                        </React.Fragment>
                    )}
                </Modal.Body>
            </Modal>
        </React.Fragment>
    )
}

export default ReportsClassifications;
